import type { FaireProductEntity } from "../../entity_types/product";

export const p_eqc4y4jx4m: FaireProductEntity = {
  token: "p_eqc4y4jx4m",
  type: "product",
  name: "Confetti Coin- Evil Eye- Moon and Stars- Stainless Steel 14K",
  brandToken: "b_sf3pyfue5x",
  brandName: "HoopLa",
  imageUrl:
    "https://cdn.faire.com/fastly/61fa856031c2a1219efc20a86fea33c49fb513bc35010b45b2ae64142e48dadf.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9896df8f99dc3c48ad457dc00b9d823f99e4313da8b075cdc80093282b992de6.png",
    "https://cdn.faire.com/fastly/344c836e8cce68ec6301d7c7167e53fc36cd2e022b8d8d53bf38441066ddd9b1.png",
    "https://cdn.faire.com/fastly/d9adef2beec502b766208f3599f877ab64f19d4ccd3d4aa1148c0846312f6dab.png",
    "https://cdn.faire.com/fastly/0b5be19f89df6d5db5f85a59595bbfb0cfbfb2c772ba6f6090e2e2a2c7ebffae.png",
  ],
  priceDollars: 21.92,
  description:
    'Confetti style Gold Coin Pendant with 9 set stones\nStainless Steel 14K gold hammered and carved Coin Pendant. \nEach stone is hand set bezel. The eye, moon and star are carved out. \nCurb Steel Chain 16" with 2" extender\n1" drop Pendant\nLobster claw clasp\nEvil Eye, Moon, Star, Pearl, Planet, Universe\n\nWaterproof\nHypoallergenic\nNON Tranishing\n',
  tags: [],
  msrpDollars: 43.83,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:43.595Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
